<template>
    <div class="container">
        <van-nav-bar title="卡片详情" left-text="" left-arrow @click-left="onClickLeft">
        </van-nav-bar>

        <div class="list-box">
            <div class="list">所属机构：{{ objDetail.organizationFullName }}</div>
            <div class="list">活动小区：{{ objDetail.communityName }}</div>
            <div class="list">虚拟卡号：{{ objDetail.id }}</div>
            <div class="list">用户手机：{{ objDetail.mobile }}</div>
            <div class="list">绑卡状态：{{ objDetail.bindingDesc }}
                <span v-if="objDetail.isBinding" class="stop" @click="onUnbind">解绑</span>
            </div>
            <div class="list">卡片序号：{{ objDetail.cardNo }}</div>
            <div class="list">账户余额：{{ objDetail.totalAmount }}元
                <!-- <span v-if="objDetail.totalAmount > 0" class="stop"
                    @click="onClear(objDetail.mobile, objDetail.tenantId)">清零</span> -->
            </div>
            <div class="list">充值余额：{{ objDetail.payAmount }}元</div>
            <div class="list">赠送余额：{{ objDetail.givingAmount }}元</div>
            <div class="list">创建时间：{{ objDetail.createTime }}</div>
            <div class="list">绑卡时间：{{ objDetail.bindingTime }}</div>
            <div class="list">解绑时间：{{ objDetail.unBindingTime ? objDetail.unBindingTime : "" }}</div>
        </div>

        <van-divider />
        <div class="title">变动记录</div>
        <van-list v-model="loading" :finished="finished" :finished-text="list.length > 0 ? '没有更多了' : '暂无数据'" @load="onLoad">
            <div class="list-box">
                <div :key="index" v-for="(item, index) in list">
                    <div class="list3 clearfix">
                        <div class="fl_left">
                            <div class="textAlign">消费类型：{{ item.typeDesc }}</div>
                            <div class="textAlign">余额：{{ (item.consumedAmount / 100).toFixed(2) }}</div>
                        </div>
                        <div class="fl_right">
                            <div class="textAlign">消费说明：{{ item.noteDesc }}</div>
                            <div class="textAlign">账户余额：{{ (item.totalAmount / 100).toFixed(2) }}</div>
                        </div>
                    </div>

                    <div class="textAlign">时间：{{ item.createTime }}</div>
                </div>
            </div>
        </van-list>

    </div>
</template>
  
<script>
import axios from '@/axios.js';
import { NavBar, Icon, Image, Toast, Loading, List, Divider } from 'vant';
export default {
    data() {
        return {
            objDetail: {},
            allCount: 0,
            pageIndex: 1,
            pageSize: 10,
            loading: false,
            finished: false,
            list: [],
        };
    },
    components: {
        [NavBar.name]: NavBar,
        [Icon.name]: Icon,
        [Image.name]: Image,
        [Toast.name]: Toast,
        [Loading.name]: Loading,
        [List.name]: List,
        [Divider.name]: Divider,
    },
    methods: {
        async getDetail() {
            let res = await axios.get('/card/get?id=' + this.$route.query.id, {});
            this.objDetail = res.data;
            this.getConsumedlist();
        },
        getConsumedlist() {
            this.loading = true;
            axios.post("/card/consumedlist", {
                pageIndex: this.pageIndex,
                pageSize: this.pageSize,
                filter: this.$route.query.id
            }).then((res) => {
                // 加载状态结束
                this.loading = false;
                this.list = res.data.list;
                this.allCount = res.data.total;
            }).catch(() => {
                this.loading = false;
            }).finally(() => {
                Toast.clear();
            })
        },
        getMoreList() {
            axios.post("/card/consumedlist", {
                pageIndex: this.pageIndex,
                pageSize: this.pageSize,
                filter: this.$route.query.id
            }).then((res) => {
                this.list = this.list.concat(res.data.list);
                this.allCount = res.data.total;
                // 加载状态结束
                this.loading = false;
                // 数据全部加载完成
                if (this.pageIndex * this.pageSize >= this.allCount || this.allCount == 0) {
                    this.finished = true;
                }
            }).catch((err) => {
                this.loading = false;
            })
        },
        onLoad() {
            // 异步更新数据
            setTimeout(() => {
                this.pageIndex++;
                this.getMoreList();
            }, 500)
        },
        onUnbind() {
            Toast.loading({
                duration: 0,       // 持续展示 toast
                forbidClick: true, // 禁用背景点击
                loadingType: 'spinner',
                message: '解绑中...'
            });
            axios.get('/card/unbinding?cardId=' + this.$route.query.id, {})
                .then((res) => {
                    if (res.isSuccess) {
                        this.getDetail();
                    }
                }).finally(() => {
                    Toast.clear();
                })

        },
        onClear(mobile) {
            Toast.loading({
                duration: 0,       // 持续展示 toast
                forbidClick: true, // 禁用背景点击
                loadingType: 'spinner',
                message: '清零中...'
            });
            axios.get('/utils/setcardamounttozerotenant?mobile=' + mobile + '&tenantId=' + this.$route.query.tenantId, {})
                .then((res) => {
                    if (res.isSuccess) {
                        this.getDetail();
                    }
                }).finally(() => {
                    Toast.clear();
                })
        },

        onClickLeft() {
            this.$router.back();
        },
        onClickRight() {

        },
    },
    computed: {
    },
    created() {
        Toast.loading({
            duration: 0,       // 持续展示 toast
            forbidClick: true, // 禁用背景点击
            loadingType: 'spinner',
            message: '数据加载中...'
        });
        this.getDetail();
    },
    mounted() {

    },
    destroyed() { }
}
</script>
<style lang="less" scoped>
body,
html {
    width: 100%;
    height: 100%;
    background: #fff;
}

.container {
    width: 100%;
    min-height: 100vh;
    letter-spacing: 0px;
    background: #fff;
}

.list-box {
    width: 100%;
    color: #373737;
    padding: 12px 20px 0 20px;

    .list {
        font-size: 14px;
        width: 100%;
        margin-bottom: 10px;

        .width200 {
            width: 230px;
            display: inline-block;
        }
    }

    .list2 {
        font-size: 14px;
        width: 50%;
        margin-bottom: 10px;
        display: inline-block;
    }

    .list3 {
        font-size: 14px;
        width: 100%;
        background: #fff;
        margin: 12px 0 0 0;

        display: flex;
        justify-content: space-between;
    }

}

.stop {
    color: #0000EE;
    border: 1px solid #0000EE;
    border-radius: 10px;
    padding: 0 5px;
    margin-left: 10px;
}

.title {
    font-size: 14px;
    font-weight: bold;
    text-align: left;
    color: #373737;
    padding: 0 0 0 20px;
}
</style>
  